<div class="container admin-level">
  <br />
  <mat-tab-group *ngIf="settings">
    <mat-tab label="Kostnader">
      <br />
      <mat-tab-group *ngIf="settings">
        <mat-tab label="Exakta" #exaktaTab>
          <mat-tab-group *ngIf="exaktaTab.isActive">
            <mat-tab label="Generellt">
              <br />
              <table class="styled fullwidth">
                <tr>
                  <th>SKU</th>
                  <th>{{ 'Print' | translate }}</th>
                  <th>{{ 'Emballage/frakt' | translate }}</th>
                </tr>
                <tr *ngFor="let sku of availableExaktaSKUs">
                  <td>
                    {{sku}}
                  </td>
                  <td>
                    <mat-form-field class="">
                      <input type="number" matInput [(ngModel)]="settings.productionCosts.skus[sku].printCost">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="">
                      <input type="number" matInput [(ngModel)]="settings.productionCosts.skus[sku].shippingCost">
                    </mat-form-field>
                  </td>
                  <td>
    
                  </td>
                </tr>
              </table>
            </mat-tab>
            
            <mat-tab *ngFor="let country of settings.productionCosts.countrySpecificShippingCosts | keyvalue"
              label="{{country.key.toUpperCase()}}">
              <br />
              <table class="styled fullwidth">
                <tr>
                  <th>SKU</th>
                  <th>{{ 'Emballage/frakt' | translate }}</th>
                </tr>
                <tr *ngFor="let sku of availableExaktaSKUs">
                  <td>
                    {{sku}}
                  </td>
                  <td>
                    <mat-form-field class="">
                      <input type="number" matInput [(ngModel)]="country.value[sku].shippingCost">
                    </mat-form-field>
                  </td>
                  <td>

                  </td>
                </tr>
              </table>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

      </mat-tab-group>

    </mat-tab>
    <mat-tab label="Leverantörer">
      <br />
      <table class="styled fullwidth">
        <tr>
          <th>{{ 'Namn' | translate }}</th>
          <th>{{ 'Kommission(%)' | translate }}</th>
          <th><span class="material-symbols-outlined clickable" (click)="addVendor()">add</span></th>
        </tr>
        <tr *ngFor="let vendor of settings.vendors">
          <td>
            <mat-form-field class="">
              <input type="text" matInput [(ngModel)]="vendor.name">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="">
              <input type="number" matInput [(ngModel)]="vendor.comissionPercent">
            </mat-form-field>
          </td>
          <td>
            <span class="material-symbols-outlined clickable" (click)="removeVendor(vendor)">remove</span>
          </td>
        </tr>
      </table>
    </mat-tab>
    <mat-tab label="Motivgenerering">
      <br />
      <div *ngIf="settings.artworkGenerationSettings">
        <h3>{{ 'Genereringsläge' | translate }}</h3>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Läge' | translate }}</mat-label>
              <mat-select [(ngModel)]="settings.artworkGenerationSettings.mode">
                <mat-option value="batch">{{ 'Batch' | translate }}</mat-option>
                <mat-option value="synchronous">{{ 'Direkt' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <p class="mode-description" *ngIf="settings.artworkGenerationSettings.mode == 'batch'">
              {{ 'Batch: ca 50% billigare, men OpenAI garanterar bara leverans inom 24 timmar.' | translate }}
            </p>
            <p class="mode-description" *ngIf="settings.artworkGenerationSettings.mode == 'synchronous'">
              {{ 'Direkt: full kostnad, men bilderna är klara inom minuter. Sänk motiv per körning till 4–6.' | translate }}
            </p>
          </div>
        </div>

        <p class="mode-note">
          {{ 'Läget läses när en batch skickas och sparas på batchen. Batchar som redan är igång påverkas inte av en ändring här.' | translate }}
        </p>

        <div class="row">
          <div class="col-6 col-md-3">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Kvalitet' | translate }}</mat-label>
              <mat-select [(ngModel)]="settings.artworkGenerationSettings.quality">
                <mat-option value="low">{{ 'Låg' | translate }}</mat-option>
                <mat-option value="medium">{{ 'Mellan' | translate }}</mat-option>
                <mat-option value="high">{{ 'Hög' | translate }}</mat-option>
                <mat-option value="auto">{{ 'Auto' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Motiv per körning' | translate }}</mat-label>
              <input matInput type="number" min="1" [(ngModel)]="settings.artworkGenerationSettings.maxArtworksPerRun">
              <mat-hint>{{ 'Sänk till 4–6 i direktläge.' | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Produkter per körning' | translate }}</mat-label>
              <input matInput type="number" min="1" [(ngModel)]="settings.artworkGenerationSettings.maxProductsPerRun">
            </mat-form-field>
          </div>
          <div class="col-6 col-md-3">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Parallella anrop (direktläge)' | translate }}</mat-label>
              <input matInput type="number" min="1" [(ngModel)]="settings.artworkGenerationSettings.synchronousConcurrency">
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Passepartout">
      <br />
      <p class="mode-note">
        {{ 'Bredden på passepartouten per posterstorlek, i millimeter. Styr B-koden i Shopify-variantens SKU, till exempel 35 → B35W. Endast 10–99 mm kan användas.' | translate }}
      </p>
      <table class="styled compact" *ngIf="settings.passepartoutWidths">
        <tr>
          <th>{{ 'Storlek' | translate }}</th>
          <th>{{ 'Bredd (mm)' | translate }}</th>
          <th>{{ 'SKU-kod' | translate }}</th>
        </tr>
        <tr *ngFor="let size of availablePosterSizes">
          <td>{{ size }}</td>
          <td>
            <mat-form-field>
              <input matInput type="number" min="0" max="99"
                [(ngModel)]="settings.passepartoutWidths[size]">
            </mat-form-field>
          </td>
          <td>{{ passepartoutCode(size) || '-' }}</td>
        </tr>
      </table>
    </mat-tab>
    <mat-tab label="Synka prislista">
      <br />
      <button mat-raised-button [disabled]="syncingPriceList" color="primary" (click)="syncPriceList()">{{ 'Synka' | translate }}</button>
      <div *ngIf="syncResult">
        <h4>Skapade Exakta-SKUer: {{syncResult.addedExaktaSKUs}}</h4>
        <h4>Ändrade Exakta-printkostnader: {{syncResult.adjustedExaktaPrintCosts}}</h4>
        <h4>Ändrade Exakta-fraktkostnader: {{syncResult.adjustedExaktaShippingCosts}}</h4>
        <div *ngFor="let store of syncResult.stores | keyvalue">
          <h3>{{store.key}}</h3>
          <h4>Skapade SKUer: {{$any(store.value).addedCreditSKUs}}</h4>
          <h4>Ändrade printpriser: {{$any(store.value).adjustedCreditPrintPrices}}</h4>
          <h4>Ändrade följandepriser: {{$any(store.value).adjustedCreditAdditionalPrices}}</h4>
          <h4>Ändrade fraktpriser: {{$any(store.value).adjustedCreditShippingPrices}}</h4>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div>
    <br />
    <button mat-raised-button color="primary" (click)="save()">{{ 'Spara' | translate }}</button>
  </div>
</div>